import { reduceZoomDomain } from '../../../../core/components/interactions-state-helpers/reducers/zoom-reducers.js';
import { getZoomStep } from '../../../../core/components/zoom/utils/get-zoom-step.js';
import type { ZoomChangeType } from '../../../../core/types/zoom.js';
import { useSetState } from '../../../hooks/store/state-setters.js';
import { useHistogramInteractions } from '../../../hooks/useHistogramInteractions.js';
import { useHistogramXScale } from '../../../hooks/useHistogramXScale.js';
import { useInfiniteZoomConfig } from '../../../hooks/useInfiniteZoomConfig.js';

/**
 * Returns a callback which given a delta in pixels, will apply the zoom interaction and update the state accordingly
 */
export const useApplyZoomDelta = () => {
  const { onZoomChange } = useHistogramInteractions();

  const { xScale, initialXScale } = useHistogramXScale();
  const infiniteZoom = useInfiniteZoomConfig();
  const setState = useSetState();

  const initialDomain = initialXScale.domain();

  return (deltaStart: number, deltaEnd: number, type: ZoomChangeType) => {
    const { nextDomain, zoomInEnabled, zoomOutEnabled } = getZoomStep(
      xScale,
      [initialDomain[0], initialDomain[1]],
      infiniteZoom,
      deltaStart,
      deltaEnd,
    );

    onZoomChange?.(nextDomain[0], nextDomain[1], type);
    setState(
      reduceZoomDomain(
        nextDomain as [number, number],
        zoomInEnabled,
        zoomOutEnabled,
      ),
    );
  };
};
